import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 16px;
`

export const InfoText = styled.p`
  color: ${Tokens.ColorTextSecondary};
  font-size: 14px;
  text-align: center;
  margin: 0;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 16px;
`

export const ActionButton = styled.div`
  width: 7rem;
`

export const ConfigListContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid ${Tokens.ColorLight};
  border-radius: 8px;
  padding: 8px;
`

export const LoadingMessage = styled.div`
  text-align: center;
  padding: 2rem;
  color: ${Tokens.ColorTextSecondary};
`

export const EmptyMessage = styled.div`
  text-align: center;
  padding: 2rem;
  color: ${Tokens.ColorTextSecondary};
`

export const FilterDetailsContainer = styled.div`
  border: 1px solid ${Tokens.ColorLight};
  border-radius: ${Tokens.RadiusInput};
  padding: 16px;
  margin: 16px 0;
  width: 100%;
  box-sizing: border-box;
`

export const FilterDetailsTitle = styled.h4`
  margin: 0 0 12px 0;
  color: ${Tokens.ColorTextPrimary};
  font-size: 14px;
  font-weight: 600;
`

export const FilterDetailsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const FilterTag = styled.span`
  background-color: ${Tokens.ColorUIPrimary};
  color: ${Tokens.ColorWhite};
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
`

export const EmptyFiltersMessage = styled.p`
  margin: 0;
  color: ${Tokens.ColorTextSecondary};
  font-size: 14px;
  font-style: italic;
`

export const ConfigItem = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;
  margin: 8px 0;
  border: 2px solid ${({ $selected }) => ($selected ? Tokens.ColorUIPrimary : Tokens.ColorLight)};
  border-radius: 8px;
  background-color: ${({ $selected }) => ($selected ? Tokens.ColorUISecondaryLight : Tokens.ColorWhite)};
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 16px;
`

export const ConfigDetails = styled.div`
  flex: 1;
  min-width: 0;
`

export const ConfigName = styled.h4`
  margin: 0 0 4px 0;
  color: ${Tokens.ColorTextPrimary};
  font-size: 16px;
`

export const ConfigDate = styled.p`
  margin: 0 0 12px 0;
  font-size: 12px;
  color: ${Tokens.ColorTextSecondary};
`

export const ConfigPreview = styled.div`
  margin-top: 8px;
`

export const ConfigPreviewTitle = styled.p`
  margin: 0 0 8px 0;
  color: ${Tokens.ColorTextSecondary};
  font-size: 12px;
  font-weight: 600;
`

export const ConfigPreviewContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`

export const ConfigPreviewTag = styled.span`
  background-color: ${Tokens.ColorUIPrimary};
  color: ${Tokens.ColorWhite};
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 11px;
  font-weight: 500;
`

export const ConfigActions = styled.div`
  display: flex;
  align-items: flex-start;
  padding-top: 4px;
`
